import { IconStars, Spacing } from '@kezios/design-system';
import { Flex, FlexProps, Text } from '@mantine/core';

import { CheckIcon } from './CheckIcon/CheckIcon';

export type CheckItemProps = {
  text: string;
  isDisabled?: boolean;
  isBold?: boolean;
  rightSection?: React.ReactNode;
} & FlexProps;

export const CheckItem = ({
  text,
  isDisabled = false,
  isBold = false,
  rightSection,
}: CheckItemProps) => {
  return (
    <Flex gap={Spacing.s2} justify="space-between" align="center">
      <Flex
        gap={Spacing.s2}
        opacity={isDisabled ? '50%' : '100%'}
        direction="row"
        justify="flex-start"
      >
        <CheckIcon size={24} isDisabled={isDisabled} />
        <Text
          variant={`textMd.${isBold ? 'semibold' : 'regular'}`}
          c={'gray.6'}
        >
          {text}
        </Text>
        {isBold && <IconStars size={24} />}
      </Flex>
      {rightSection}
    </Flex>
  );
};
